module.exports = "<div class=\"fourohfour\">\n  <div class=\"container\">\n    <h1 ng-hide=\"message\">This page is dead, but your night isn't</h1>\n    <h1 ng-show=\"message\">{{ message }}</h1>\n    <p>The information you requested could not be found.</p>\n    <button ng-click=\"browseVenues()\" href=\"#\" class=\"btn btn-default\">Browse Venues</button>\n\n    {{ message }}\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/errorNotFound/errorNotFound.html
// module id = 814
// module chunks = 1